import {useActions, useGetters, useMutators, useState} from './_default';
import {getFormLocalStorage, storeToLocalStorage} from "@/js/helpers.js";
export default {
    namespaced: true,
    state: {
        ...useState(),
        recent: null,
        favorite: null,
        userMenu: [],
    },
    getters: {
        ...useGetters(),
        recent: (state) => {
            if (state.recent === null) {
                state.recent = [];
                const list = getFormLocalStorage('qm-recent');
                if (list) {
                    state.recent = JSON.parse(list);
                }
            }

            return state.recent;
        },

        favorite: (state) => {
            if (state.favorite === null) {
                state.favorite = [];
                const list = getFormLocalStorage('qm-favorite');
                if (list) {
                    state.favorite = JSON.parse(list);
                }
            }

            return state.favorite;
        },

        userMenu: state => state.userMenu,
    },
    mutations: {
        ...useMutators(),
        add(state, links) {
            state.list = [...state.list, ...links];
        },

        userMenu(state, list) {
            state.userMenu = list;
        },

        addToRecent(state, link) {
            if (state.recent.length === 5) {
                state.recent.pop();
            }

            state.recent.unshift(link.name);
            storeToLocalStorage('qm-recent', JSON.stringify(state.recent));
        },

        addToFavorite(state, link) {
            const index = state.favorite.indexOf(link.name);
            if (index !== -1) return;
            
            if (state.favorite.length === 5) {
                state.favorite.splice(state.favorite.length - 1, 1);
            }

            state.favorite.push(link.name);
            storeToLocalStorage('qm-favorite', JSON.stringify(state.favorite));
        },

        removeFromFavorite(state, link) {
            const index = state.favorite.indexOf(link.name);
            if (index === -1) return;
            state.favorite.splice(index, 1);
            storeToLocalStorage('qm-favorite', JSON.stringify(state.favorite));
        }
    },
    actions: {
        ...useActions(),
    },
}
